// ALL THE NEW PLATFORMS SHOULD BE ON LOWER CASE
export enum Platform {
  app = 'app',
  biteninja = 'biteninja',
  doordash = 'doordash',
  googleFoodOrdering = 'googleFoodOrdering', // TODO : change this to lower case
  grubhub = 'grubhub',
  kiosk = 'kiosk',
  skip = 'skip',
  uber = 'uber',
  waitr = 'waitr',
  web = 'web',
}
